export default "__VITE_ASSET__CsXrvBiH__"